export const initialsName = (name: string) => {
  const [firstName, lastName] = name.split(" ");

  let sigla = "";
  if (firstName && lastName) {
    sigla = `${firstName[0]}${lastName[0]}`.toUpperCase();
  } else {
    sigla = firstName.substr(0, 2).toUpperCase();
  }

  return sigla;
};
